import { useProviderDetailStore } from "../../store/provider-details/providerDetailStore";

import AdditionalContactEditView from "./AddionalContactEditView";

export default function AdditionalEmailsEditView(props) {
  const { additionalEmailTypes, modifiedData } = useProviderDetailStore();

  return (
    <AdditionalContactEditView
      {...props}
      typesMap={additionalEmailTypes}
      order={modifiedData.emailOrder ?? []}
      orderKey="emailOrder"
      dataMap={modifiedData.emails}
      valueKey="email"
      addButtonLabel="Add Email"
      emptyText="No additional emails"
      fieldSuffixLabel="Email"
      placeholder="name@example.com"
    />
  );
}
